import React from "react";
import { Typography, Toastify } from "top-brains-ui";
import ActivationImage from "@src/assets/password-link-exp-img.svg";
import styles from "@src/pages/login/set-password-link-expired/SetPasswordLinkExpired.module.scss";
import { useNavigate } from "react-router-dom";
import GradiantButton from "@src/components/gradiant-btn/GradiantButton";
import { setUserLogin } from "@src/app/globalSlice";
import { useDispatch } from "react-redux";
// import { WEBSITE_COLORS } from "@src/styles/ColorConstants";

const ResetPasswordLinkExpired: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignInClick = () => {
    navigate("/");
    dispatch(setUserLogin(true));
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.msgTitle}>
          <Typography
            fontWeight="semi-bold"
            fontSize={24}
            color="var(--modal-heading-color)"
            className={styles.linkExpired}
          >
            Your Reset Password link is expired
          </Typography>
        </div>
        <div className={styles.imageContainer}>
          <img src={ActivationImage} alt="activation_img" />
        </div>
        <div className={styles.msgBody}>
          <div>
            <Typography
              fontSize={16}
              color="var(--modal-body-color)"
              className={styles.description}
            >
              Missed your password reset? No worries! You can request it again
              to reset your password.
            </Typography>
          </div>
        </div>
        <div className={styles.resendBtn}>
          <GradiantButton
            variant="primary"
            label="Back to Sign In"
            width="400px"
            height="44px"
            fontSize={16}
            className={styles.backToSign}
            labelClassName={styles.buttonLabel}
            onClick={handleSignInClick}
          />
        </div>
      </div>
      <Toastify />
    </>
  );
};

export default ResetPasswordLinkExpired;
